import { Badge } from "@/components/ui/badge";
import { CheckCircle, ArrowRight } from "lucide-react";
import { getWhatsAppLink } from "@/lib/whatsapp";

const AboutSection = () => {
  return (
    <section id="about" className="py-20 bg-white" data-testid="about-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Image Side */}
          <div className="relative">
            <div className="relative z-10">
              <img
                src="/images/about/technician.jpeg"
                alt="HVAC Technician"
                className="rounded-2xl shadow-2xl w-full"
              />
            </div>
            <div className="absolute -bottom-6 -right-6 bg-gradient-to-br from-amber-500 to-yellow-500 rounded-2xl p-6 text-black shadow-xl z-20">
              <div className="text-4xl font-bold">45+</div>
              <div className="text-sm opacity-80">Years of Excellence</div>
            </div>
            <div className="absolute -top-6 -left-6 w-32 h-32 bg-amber-100 rounded-2xl -z-10"></div>
          </div>

          {/* Content Side */}
          <div>
            <Badge className="bg-amber-100 text-amber-700 mb-4">About MARCO AIR CONDITION</Badge>
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6" data-testid="about-title">
              Your Trusted Partner for All HVAC Needs
            </h2>
            <p className="text-lg text-gray-600 mb-6 leading-relaxed">
              MARCO AIR CONDITION is a leading HVAC service provider based in Surat, Gujarat. We specialize in providing comprehensive air conditioning solutions for residential, commercial, and industrial clients.
            </p>
            <p className="text-lg text-gray-600 mb-8 leading-relaxed">
              With our team of certified technicians and commitment to quality, we ensure that every project is completed to the highest standards. For VRF and Ductable projects, we serve clients across India.
            </p>

            {/* Features */}
            <div className="grid sm:grid-cols-2 gap-4 mb-8">
              {[
                { icon: <CheckCircle className="h-5 w-5 text-amber-500" />, text: "Licensed & Certified Technicians" },
                { icon: <CheckCircle className="h-5 w-5 text-amber-500" />, text: "All Major Brands Serviced" },
                { icon: <CheckCircle className="h-5 w-5 text-amber-500" />, text: "Competitive Pricing" },
                { icon: <CheckCircle className="h-5 w-5 text-amber-500" />, text: "Quality Guaranteed Work" },
              ].map((item, index) => (
                <div key={index} className="flex items-center gap-3">
                  {item.icon}
                  <span className="text-gray-700">{item.text}</span>
                </div>
              ))}
            </div>

            <a 
              href={getWhatsAppLink("Hi! I would like to learn more about MARCO AIR CONDITION services.")}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 bg-gradient-to-r from-amber-500 to-yellow-500 hover:from-amber-600 hover:to-yellow-600 text-black font-semibold px-6 py-3 rounded-md transition-all"
              data-testid="about-cta"
            >
              <svg className="h-5 w-5" fill="currentColor" viewBox="0 0 24 24">
                <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
              </svg>
              Connect on WhatsApp
              <ArrowRight className="h-5 w-5" />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
